<div>
  <portal-icon-button [iconClass]="isChecked ? 'far fa-check-circle' : 'far fa-circle'"></portal-icon-button>
</div>
